import { systemPreferencesInternalConfig } from "./system-preferences-config.internal";
import { Injectable } from "@angular/core";
import { TCMCurrencyInputConfig } from "../modules/tcm-form/configs/tcm-currency-input.config";
import { TCMFormConfig } from "../modules/tcm-form/tcm-form-config";

class WafCurrencyInputConfigImpl implements TCMCurrencyInputConfig {
  get currencySign() {
    return systemPreferencesInternalConfig.currencySign;
  }
}

@Injectable()
export class TcmWafFormConfig implements TCMFormConfig {

  constructor(){    
  }

  timePicker = {
    minuteStep: 15
  };

  wafCurrencyInput = new WafCurrencyInputConfigImpl();

  get currencySign() {
    return systemPreferencesInternalConfig.currencySign;
  }
}